import { GoogleChartWrapperChartType } from 'react-google-charts'
import { StyledGoogleChart } from '../Cockpit.styles'
import { CustomChart } from '../Cockpit.types'
import { getCardChartData } from '../utils/getCardChartData'
import CardItem from './CardItem'
import { DataChart } from './ChartWrapper'
import GroupedCardChart from './GroupedCardChart'
import { CardContainer, CardItemContainer } from './styles'

const GROUP_INDEX = 5

export interface CardChartProps {
  chartModel: GoogleChartWrapperChartType | CustomChart
  data: DataChart
  title?: string
  measurementUnit?: string
}

const CardChart = ({
  chartModel,
  data,
  title,
  measurementUnit
}: CardChartProps) => {
  const chartData = [...data]

  const hasGroupedData = chartData.some((row) => row.length > GROUP_INDEX)

  if (hasGroupedData) {
    const data = getCardChartData(chartData, GROUP_INDEX)
    return <GroupedCardChart data={data} />
  }

  return (
    <StyledGoogleChart {...{ chartModel }}>
      {title && <h2>{title}</h2>}

      <CardContainer>
        {chartData.map((item, index) => (
          <CardItemContainer key={`card-container-${index}`}>
            <CardItem
              backgroundColor={item?.[2]}
              title={item[0]}
              image={item?.[3]}
              count={item[1]}
              textForInformationCard={item?.[4]}
              measurementUnit={measurementUnit}
            />
          </CardItemContainer>
        ))}
      </CardContainer>
    </StyledGoogleChart>
  )
}

export default CardChart
